import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import ExperienceInputs from "../../../components/Experience/ExperienceInputs";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { getExperienceData } from "../../../utils/ApiCalls/Experience";
import { getShortCutsData } from "../../../utils/ApiCalls/Shortcuts";
import ShortcutsInput from "../../../components/Shortcuts/ShortcutsInput";

const EditShortcuts = () => {
  const params = useParams();
  const [experience, setExperience] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Experience",
      route: "/website/cms/homepage/experience",
    },
    {
      title: "Edit Experience",
      route: "/website/cms/homepage/experience/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getShortCutsData({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setExperience(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Shortcuts"}>
       <CustomHeaderTitle title={"Edit Shortcuts"}/>
      <HeaderBread
        navigation={navigation}
        title={"Edit Shortcuts"}
      ></HeaderBread>
      {experience && <ShortcutsInput experience={experience} />}
    </Layout>
  );
};

export default EditShortcuts;
